<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<svelte:options customElement="map-tool" />

<script>
  import MapTool from "$components/MapTool/MapTool.svelte";
  import { FontsUrban } from "@urbaninstitute/dataviz-components";
  import state_data from "$data/map/state.csv";
  import urban_data from "$data/map/urban.csv";
  import config_data from "$data/map/config.csv";

</script>

<FontsUrban />
<MapTool
  data={state_data}
  tableData={urban_data}
  configData={/** @type {import("$utils/config").ColumnConfig[]} */ (config_data)}
  showStateSummary={true}
/>
